import { decimalAdd } from './getCalculatedValue'

// 去除对象中空属性
export function removeNull(data = {}) {
  const newObj = {}
  for (var key in data) {
    if (data[key]) {
      newObj[key] = data[key]
    }
  }
  return newObj
}

export function resolveBannerTagType(type) {
  if (type === 'danger' || type === 'error' || type === 'warning') {
    return 'danger'
  }
  if (type === 'success') return 'success'
  return ''
}

export function bannerTagIcon(type) {
  const resolved = resolveBannerTagType(type)
  if (resolved === 'success') return 'el-icon-success'
  if (resolved === 'danger') return 'el-icon-error'
  return 'el-icon-info'
}

export function pickPersonUid(source) {
  if (!source) return ''
  if (typeof source === 'string' || typeof source === 'number') {
    return String(source).trim()
  }
  if (typeof source !== 'object') return ''
  const value =
    source.personUid ||
    source.personuid ||
    source.person_uid ||
    source.PERSONUID ||
    source.PERSON_UID ||
    ''
  return value ? String(value).trim() : ''
}

export function pickLaborTeamUid(source) {
  if (!source || typeof source !== 'object') return ''
  const value =
    source.laborTeamUid ||
    source.laborteamuid ||
    source.labor_team_uid ||
    source.LABOR_TEAM_UID ||
    ''
  return value ? String(value).trim() : ''
}

export function asResultList(data) {
  const list = data && data.result
  if (Array.isArray(list)) return list
  if (list && typeof list === 'object') return [list]
  return []
}

export function asRows(data) {
  if (Array.isArray(data)) return data
  if (!data || typeof data !== 'object') return []
  if (Array.isArray(data.result)) return data.result
  if (Array.isArray(data.data)) return data.data
  if (Array.isArray(data.list)) return data.list
  if (Array.isArray(data.rows)) return data.rows
  if (data.result && typeof data.result === 'object') {
    return asRows(data.result)
  }
  const keys = Object.keys(data)
  if (!keys.length) return []
  const wrappers = {
    result: 1,
    data: 1,
    list: 1,
    rows: 1,
    total: 1,
    totalSize: 1,
    page: 1,
    limit: 1,
    code: 1,
    msg: 1,
    message: 1
  }
  const hasRecordKey = keys.some((key) => !wrappers[key])
  if (hasRecordKey) return [data]
  return []
}

const LABOR_CONTRACT_STATUS_LABEL = {
  '-1': '未备案',
  no: '未备案',
  未备案: '未备案',
  2: '待签名',
  signature_wite: '待签名',
  待签名: '待签名',
  4: '被拒绝',
  refuse: '被拒绝',
  被拒绝: '被拒绝',
  1: '已备案',
  current: '已备案',
  已备案: '已备案',
  3: '报备审核中',
  approval: '报备审核中',
  报备审核中: '报备审核中',
  0: '已终止',
  已终止: '已终止',
  变更审核中: '变更审核中'
}

const LABOR_CONTRACT_REPORTABLE = {
  未备案: true,
  待签名: true,
  被拒绝: true
}

export function laborContractStatusCode(row) {
  if (row == null) return ''
  const raw = row.statusCode != null ? row.statusCode : row.status
  return String(raw == null ? '' : raw).trim()
}

export function laborContractStatusLabel(status) {
  const code = String(status == null ? '' : status).trim()
  return LABOR_CONTRACT_STATUS_LABEL[code] || '未备案'
}

export function canBatchReportLaborContract(row) {
  const label = laborContractStatusLabel(laborContractStatusCode(row))
  return !!LABOR_CONTRACT_REPORTABLE[label]
}

export function stripFormerNameSuffix(name) {
  return String(name || '')
    .replace(/（曾用名：[^）]*）/g, '')
    .trim()
}

export function formatFormerName(name) {
  return stripFormerNameSuffix(name)
}

export function formerNameTooltip(tipKey = 'formerName') {
  return {
    tipKey,
    tipLabel: '曾用名：'
  }
}

export function fillBidProjectCode(item, bids) {
  if (!item) return
  const bidUid =
    item.projectUid || item.upVproUid || item.orgUid || item.vProjectUid
  const bid = (bids || []).find(
    (row) =>
      row &&
      (String(row.value) === String(bidUid) ||
        String(row.orgUid) === String(bidUid))
  )
  const bidText = bid
    ? bid.orgCode ||
      String(bid.label || '')
        .replace(/（在建）|（停工）|（完工）/g, '')
        .trim()
    : ''
  item.projectCode =
    item.vProjectName || item.projectCode || bidText || item.orgCode || ''
}

export function resolveBidShortName(item, bids) {
  if (!item) return ''
  const stripStatus = (text) =>
    String(text || '')
      .replace(/（在建）|（停工）|（完工）/g, '')
      .trim()
  const bidUid =
    item.projectUid || item.upVproUid || item.orgUid || item.vProjectUid
  const bid = (bids || []).find(
    (row) =>
      row &&
      (String(row.value) === String(bidUid) ||
        String(row.orgUid) === String(bidUid))
  )
  const fromBid = bid
    ? stripStatus(bid.orgCode || bid.projectCode || bid.label)
    : ''
  const itemCode = stripStatus(item.orgCode)
  const itemProjectCode = stripStatus(item.projectCode)
  const fullName = stripStatus(item.vProjectName || item.projectName)
  const pickShort = (value) =>
    value && value !== fullName ? value : ''
  return (
    fromBid ||
    pickShort(itemCode) ||
    pickShort(itemProjectCode) ||
    fullName ||
    itemProjectCode ||
    itemCode ||
    ''
  )
}

export function applyFormerNames(rows, statusList) {
  const map = {}
  ;(statusList || []).forEach((item) => {
    const uid = item && (item.uid || item.UID)
    if (uid) {
      map[String(uid)] = {
        formerName: item.formerName || item.formername || '',
        name: item.name || item.personName || ''
      }
    }
  })
  ;(rows || []).forEach((row) => {
    if (!row) return
    const uid = row.personUid || row.uid
    const info = uid ? map[String(uid)] : null
    const former = row.formerName || (info && info.formerName) || ''
    if (former) row.formerName = former
    const current = (info && info.name) || ''
    ;['name', 'personName'].forEach((key) => {
      if (!row[key] && !current) return
      row[key] = stripFormerNameSuffix(current || row[key])
    })
  })
  return rows
}

export function uniqueIds(list) {
  const seen = {}
  const result = []
  const raw = Array.isArray(list)
    ? list
    : list === undefined || list === null || list === ''
    ? []
    : String(list).split(/[，,、]/)
  raw.forEach((id) => {
    if (id === undefined || id === null || id === '') return
    const key = String(id).trim()
    if (!key || seen[key]) return
    seen[key] = true
    result.push(key)
  })
  return result
}

export function applyEntryTeams(rows, teamRows) {
  const byEntry = {}
  const byPerson = {}
  ;(teamRows || []).forEach((item) => {
    if (!item) return
    const raw = item.teamUids || item.teamuids || ''
    const teamUids = uniqueIds(
      Array.isArray(raw)
        ? raw
        : String(raw)
            .split(',')
            .map((id) => id.trim())
    )
    const payload = {
      teamUids,
      teamNames: item.teamNames || item.teamnames || '',
      personUid: pickPersonUid(item),
      laborTeamUid: pickLaborTeamUid(item)
    }
    const entryUid = item.entryUid || item.entryuid
    const personUid = payload.personUid
    if (entryUid) byEntry[String(entryUid)] = payload
    if (personUid) byPerson[String(personUid)] = payload
  })
  ;(rows || []).forEach((row) => {
    if (!row) return
    row.personUid = pickPersonUid(row) || row.personUid || ''
    const hit =
      byEntry[String(row.uid || row.laborUid || '')] ||
      byPerson[String(row.personUid || '')]
    if (hit) {
      row.teamUids = uniqueIds(hit.teamUids)
      if (hit.teamNames) row.teamName = hit.teamNames
      if (!pickPersonUid(row) && hit.personUid) row.personUid = hit.personUid
      if (!pickLaborTeamUid(row) && hit.laborTeamUid) {
        row.laborTeamUid = hit.laborTeamUid
      }
    } else {
      row.teamUids = uniqueIds(
        Array.isArray(row.teamUids) && row.teamUids.length
          ? row.teamUids
          : row.teamUid
      )
    }
  })
  return rows
}

export function lockRowActions(item, locked, isSuperAdmin) {
  if (!item || !locked) return
  item.disabledButtons = isSuperAdmin ? ['', 1, '', 3, ''] : ['', 1, 2, 3, '']
}

export function toTimestamp(value) {
  if (value === undefined || value === null || value === '') return 0
  if (value instanceof Date) {
    const stamp = value.getTime()
    return isNaN(stamp) ? 0 : stamp
  }
  if (typeof value === 'number' && !isNaN(value)) {
    return value > 0 && value < 1e12 ? value * 1000 : value
  }
  const str = String(value).trim()
  if (!str) return 0
  if (/^\d+$/.test(str)) {
    const num = Number(str)
    return num > 0 && num < 1e12 ? num * 1000 : num
  }
  const stamp = new Date(str.replace(/-/g, '/')).getTime()
  return isNaN(stamp) ? 0 : stamp
}

export function pickCreateTime(record) {
  if (!record) return 0
  return toTimestamp(
    record.createTime ||
      record.creatTime ||
      record.createtime ||
      record.create_time ||
      record.CREATE_TIME ||
      record.creat_time
  )
}

export function attachCreateTime(record) {
  if (!record || typeof record !== 'object') return record
  const time = pickCreateTime(record)
  if (time) record.createTime = time
  return record
}

export function pickWalkinTimestamp(walkinDate) {
  if (!walkinDate) return 0
  const str = String(walkinDate).trim().slice(0, 10)
  if (!str) return 0
  const stamp = new Date(str.replace(/-/g, '/') + ' 00:00:00').getTime()
  return isNaN(stamp) ? 0 : stamp
}

export function isRecordAfterWalkin(record, walkinDate) {
  const created = pickCreateTime(record)
  const walkin = pickWalkinTimestamp(walkinDate)
  if (!created || !walkin) return false
  return created >= walkin
}

export function buildArchiveLock(state) {
  const fv = (state && state.formValues) || {}
  const row = (state && state.currentRow) || {}
  const contractor = (state && state.contractor) || {}
  const builder = (state && state.builder) || {}
  const sources = [
    fv.laborCompany,
    fv.manageCompany,
    fv.laborPerson,
    fv.managePerson,
    contractor.laborCompanyInfo,
    contractor.manageCompanyInfo,
    builder.laborPersonInfo,
    builder.managePersonInfo,
    row.laborCompany,
    row.manageCompany,
    row.laborPerson,
    row.managePerson
  ]
  let walkinDate = ''
  let projectUid = ''
  sources.forEach((item) => {
    if (!item) return
    if (!walkinDate) {
      walkinDate =
        item.walkinDate || item.orgBeginTime || item.entryDate || ''
    }
    if (!projectUid) {
      projectUid =
        item.projectUid ||
        item.upVproUid ||
        (item.personUid ? item.orgUid : '') ||
        ''
    }
  })
  return {
    walkinDate: walkinDate || '',
    projectUid: projectUid || ''
  }
}

export function hasArchiveBidPermission(state, projectUid) {
  const user = (state && state.user) || {}
  if (user.userName && user.userName === (state && state.superAdminName)) {
    return true
  }
  const orgValue = String(user.orgValue || '')
  if (projectUid && orgValue && orgValue === String(projectUid)) {
    return true
  }
  return false
}

export function canModifyArchiveChild(record, options) {
  const opts = options || {}
  if (opts.status === 'outsideCheck' || opts.status === 'check') {
    return false
  }
  if (opts.status !== 'complete') {
    return true
  }
  const sessionNew = opts.isOriginal === false
  if (!opts.hasBidPermission) {
    return sessionNew
  }
  if (isRecordAfterWalkin(record, opts.walkinDate)) {
    return true
  }
  return sessionNew
}

/* 将数组对象key1、key2属性按规定key3、key4属性重组；
多级数据重组需要设置childrenKey;
无key3、key4参数时按label、value对应重组 */
export function resetAttribute(
  data,
  key1,
  key2,
  childrenKey = 'children',
  key3 = 'label',
  key4 = 'value'
) {
  return data.map((item) => {
    const newItem = {
      ...item,
      [key3]: item[key1] || item.label,
      [key4]: item[key2] || item.value,
      children: item[childrenKey] || item.children
    }
    if (newItem.children && Array.isArray(newItem.children)) {
      newItem.children = resetAttribute(
        newItem.children,
        key1,
        key2,
        childrenKey,
        key3,
        key4
      )
    }
    return newItem
  })
}

export function withSelectedOption(list, uid, name, extra) {
  return withSelectedOptions(list, uid, name, extra)
}

export function withSelectedOptions(list, uids, names, extra) {
  const options = Array.isArray(list) ? list.slice() : []
  const ids = uniqueIds(uids)
  const labels = Array.isArray(names)
    ? names
    : String(names || '')
        .split(/[，,、]/)
        .map((item) => item.trim())
        .filter(Boolean)
  ids.forEach((id, index) => {
    const value = String(id)
    if (!options.some((item) => item && String(item.value) === value)) {
      options.unshift(
        Object.assign(
          {
            label: labels[index] || labels[0] || value,
            value: value
          },
          extra || {}
        )
      )
    }
  })
  return options
}

export function matchOptionValue(options, current) {
  if (current === undefined || current === null || current === '') {
    return current
  }
  const list = Array.isArray(options) ? options : []
  const cur = String(current)
  const hit = list.find((item) => {
    if (!item) return false
    return (
      String(item.value) === cur ||
      String(item.uid) === cur ||
      String(item.signatureUid) === cur ||
      String(item.cardNum) === cur
    )
  })
  return hit ? hit.value : current
}

/* 将数组对象keys[]属性按规定newKeys[]属性重组
多级数据重组需要设置childrenKey;
无newKeys参数时按label、value、value2...对应重组 */
export function resetAttributes(data, keys, newKeys = [], childrenKey) {
  return data.map((item) => {
    const newItem = { ...item }

    for (let i = 0; i < keys.length; i++) {
      const sourceKey = keys[i]
      const targetKey =
        newKeys[i] || (i === 0 ? 'label' : i === 1 ? 'value' : `value${i - 1}`)

      if (sourceKey in item) {
        newItem[targetKey] = item[sourceKey]
      } else {
        newItem[targetKey] = targetKey.startsWith('value')
          ? `value${i - 1}`
          : `label${i - 1}`
      }
    }

    if (childrenKey in item && Array.isArray(item[childrenKey])) {
      newItem[childrenKey] = resetAttributes(
        item[childrenKey],
        keys,
        newKeys,
        childrenKey
      )
    }

    return newItem
  })
}

// 对象深拷贝方法
export function clone(obj) {
  if (obj === null) return null
  if (typeof obj !== 'object') return obj
  if (obj.constructor === Date) return new Date(obj)
  if (obj.constructor === RegExp) return new RegExp(obj)
  var newObj
  if (obj instanceof Array) {
    newObj = []
    for (var i = 0, len = obj.length; i < len; i++) {
      newObj.push(clone(obj[i]))
    }
  } else {
    newObj = {}
    for (var j in obj) {
      newObj[j] = clone(obj[j])
    }
  }
  return newObj
}

// 合并对象数组中相同uid的对象，并合并其中不同值的属性,
export function mergeSameKeys(array, params) {
  /* params: {
    uidKey: 对象元素中的uid值对应的key,
    joinKey: 对象元素中要拼接对应值的key,
    joinType: 拼接连接符
    totalKey: 对象元素中要合计累加对应值的key,
    toFixed: 对象元素中要合计累加后保留的小数位数
  } */
  const arr = []
  for (let i = 0; i < array.length; i++) {
    let obj = array[i]
    for (let j = i + 1; j < array.length; j++) {
      const item = array[j]
      if (obj[params.uidKey] === item[params.uidKey]) {
        if (params.joinKey) {
          obj[params.joinKey] =
            obj[params.joinKey] +
            (params.joinType ? params.joinType : '、') +
            item[params.joinKey]
        }
        if (params.totalKey && params.toFixed !== undefined) {
          obj[params.totalKey] = (
            parseFloat(obj[params.totalKey]) + parseFloat(item[params.totalKey])
          ).toFixed(params.toFixed)
        } else if (params.totalKey && params.toFixed === undefined) {
          obj[params.totalKey] =
            parseFloat(obj[params.totalKey]) + parseFloat(item[params.totalKey])
        }
        array.splice(j, 1)
        j--
      }
    }
    arr.push(obj)
  }
  return arr
}

// 数组元素去重,如果为对象数组，传入判断重复的对象id
export function getDistinct(array, id) {
  var newArr = []
  for (var i = 0; i < array.length; i++) {
    for (var j = i + 1; j < array.length; j++) {
      if (id) {
        if (array[i][id] === array[j][id]) {
          i++
          j = i
        }
      } else {
        if (array[i] === array[j]) {
          i++
          j = i
        }
      }
    }
    newArr.push(array[i])
  }
  return newArr
}

const ENTRY_SUPERSCRIPTS = '¹²³⁴⁵⁶⁷⁸⁹'
function toEntrySuperscript(seq) {
  const n = Number(seq) || 0
  if (n < 1) return ''
  if (n <= 9) return ENTRY_SUPERSCRIPTS.charAt(n - 1)
  return String(n)
}

function formatEntryDateShort(value) {
  const text = String(value || '').trim()
  if (!text) return ''
  const m = text.match(/(\d{4})-(\d{2})-(\d{2})/)
  if (m) return m[2] + '/' + m[3]
  return text.slice(0, 10)
}

/**
 * 同人同月多次进场：按 personUid 分组，按进场时间排序后打序号。
 * - nameDisplay: 张三¹
 * - entryPeriodLabel: 05/01–05/05
 * - label: 张三¹（05/01–05/05）用于下拉
 * 仅当同一人出现多条时才加序号；单条保持原名。
 */
export function annotateMultiEntryPersons(rows, options = {}) {
  const list = Array.isArray(rows) ? rows : []
  const nameKey = options.nameKey || 'name'
  const personKey = options.personKey || 'personUid'
  const entryKey = options.entryKey || 'pEntryUid'
  const walkinKeys = options.walkinKeys || [
    'walkinDate',
    'walkin_date',
    'orgBeginTime',
    'org_begin_time'
  ]
  const walkoffKeys = options.walkoffKeys || [
    'walkoffDate',
    'walkoff_date',
    'orgEndTime',
    'org_end_time'
  ]

  function pickField(row, keys) {
    for (let i = 0; i < keys.length; i++) {
      const v = row && row[keys[i]]
      if (v !== undefined && v !== null && String(v).trim() !== '') {
        return String(v).trim()
      }
    }
    return ''
  }

  const groups = {}
  list.forEach((row, index) => {
    if (!row) return
    const personUid = String(row[personKey] || row.personuid || '').trim()
    const key = personUid || '__idx_' + index
    if (!groups[key]) groups[key] = []
    groups[key].push(row)
  })

  Object.keys(groups).forEach((key) => {
    const items = groups[key]
    items.sort((a, b) => {
      const aw = pickField(a, walkinKeys)
      const bw = pickField(b, walkinKeys)
      if (aw && bw && aw !== bw) return aw < bw ? -1 : 1
      const ae = String(a[entryKey] || a.uid || '')
      const be = String(b[entryKey] || b.uid || '')
      return ae < be ? -1 : ae > be ? 1 : 0
    })
    const multi = items.length > 1
    items.forEach((row, idx) => {
      const seq = idx + 1
      const baseName = String(
        row[nameKey] || row.personName || row.label || ''
      ).trim()
      const walkin = formatEntryDateShort(pickField(row, walkinKeys))
      const walkoffRaw = pickField(row, walkoffKeys)
      const walkoff =
        !walkoffRaw || walkoffRaw === '未退场'
          ? '在场'
          : formatEntryDateShort(walkoffRaw)
      const period =
        walkin && walkoff ? walkin + '–' + walkoff : walkin || walkoff || ''
      row.entrySeq = multi ? seq : 0
      row.entryPeriodLabel = period
      row.nameBase = baseName
      const mark = multi ? toEntrySuperscript(seq) : ''
      row.nameDisplay = baseName + mark
      if (multi && period) {
        row.label = baseName + mark + '（' + period + '）'
      } else if (multi) {
        row.label = baseName + mark
      } else {
        row.label = baseName
      }
      // 下拉选项：同人多进场用 personUid|entryUid，避免 el-option value 冲突
      const personUid = String(row[personKey] || row.personuid || '').trim()
      const entryUid = String(
        row[entryKey] || row.uid || row.entryUid || ''
      ).trim()
      if (multi && personUid && entryUid) {
        row.value = personUid + '|' + entryUid
      } else if (personUid) {
        row.value = personUid
      }
      row.personUid = personUid || row.personUid
      if (entryUid) row.pEntryUid = entryUid
    })
  })
  return list
}

/** 解析人员筛选项 value（兼容 personUid 或 personUid|entryUid） */
export function resolvePersonFilterUid(value) {
  const text = String(value || '').trim()
  if (!text) return ''
  const idx = text.indexOf('|')
  return idx >= 0 ? text.slice(0, idx) : text
}

/** 解析人员筛选项为 personUid + pEntryUid */
export function resolvePersonFilter(value) {
  const text = String(value || '').trim()
  if (!text) return { personUid: '', pEntryUid: '' }
  const idx = text.indexOf('|')
  if (idx >= 0) {
    return {
      personUid: text.slice(0, idx),
      pEntryUid: text.slice(idx + 1)
    }
  }
  return { personUid: text, pEntryUid: '' }
}

/**
 * 查询参数中的复合人员 value 拆成 personUid（及可选 pEntryUid），供后端接口使用
 */
export function normalizePersonQuery(query = {}) {
  const next = Object.assign({}, query)
  const raw = next.personUid
  if (raw === undefined || raw === null || raw === '') return next
  const parsed = resolvePersonFilter(raw)
  next.personUid = parsed.personUid
  if (parsed.pEntryUid) {
    next.pEntryUid = parsed.pEntryUid
  }
  return next
}

// 处理返回对象数组中某些属性值（keys【】）的数组并去重，根据不同属性的key按对象形式返回
export function getRemoveRepeat(data, keys) {
  const obj = {}
  for (var i = 0; i < keys.length; i++) {
    const arr = []
    for (var j = 0; j < data.length; j++) {
      for (var key in data[j]) {
        if (keys[i] === key) {
          arr.push(data[j][key])
        }
      }
    }
    obj[keys[i]] = getDistinct(arr)
  }
  return obj
}

/* 
将单层级对象数组按照对象中某属性归类,
并汇总sumkey[]中属性值或保留某些同值的属性keepKeys[]在父级，
分层参数obj｛uid，label, childrenId, childrenLabel, sumKeys，keepKeys,joinKeys}
*/
export function isDirtyDictLabel(text) {
  if (text == null) return true
  const value = String(text).trim()
  if (!value || value === 'undefined' || value === 'null') return true
  if (value.indexOf('/') !== -1) {
    return value.split('/').some((part) => isDirtyDictLabel(part))
  }
  if (/^[a-z]+(?:[A-Z][a-zA-Z0-9]*)+$/.test(value)) return true
  if (/^[a-z]+(?:_[a-z0-9]+)+$/.test(value)) return true
  const fieldNames = [
    'uid',
    'label',
    'value',
    'children',
    'technicalMeasures',
    'riskProType',
    'riskWokeType',
    'riskWorkType',
    'riskSource',
    'riskFactors',
    'riskWokeCode',
    'riskFactorsType',
    'accidentType',
    'manageMeasures',
    'trainingMeasures',
    'personalProtective',
    'emergencyMeasure',
    'risk_pro_type',
    'risk_woke_type',
    'risk_work_type',
    'risk_source',
    'risk_sourc',
    'risk_woke_code',
    'risk_factors',
    'technical_measures'
  ]
  return fieldNames.indexOf(value) !== -1
}

export function scrollCascaderToSelected(visible, cascaderVm) {
  if (!visible) return
  const vm = Array.isArray(cascaderVm) ? cascaderVm[0] : cascaderVm
  const scrollMenuToNode = (menu, node) => {
    if (!menu || !node) return
    const wrap = menu.querySelector('.el-scrollbar__wrap')
    if (!wrap) return
    const wrapRect = wrap.getBoundingClientRect()
    const nodeRect = node.getBoundingClientRect()
    wrap.scrollTop +=
      nodeRect.top - wrapRect.top - wrap.clientHeight / 2 + node.clientHeight / 2
  }
  const locateMenus = (root) => {
    if (!root || !root.querySelectorAll) return
    const menus = root.querySelectorAll('.el-cascader-menu')
    menus.forEach((menu) => {
      const checkedBox =
        menu.querySelector('.el-checkbox.is-checked') ||
        menu.querySelector('.el-checkbox.is-indeterminate')
      const node =
        (checkedBox &&
          checkedBox.closest &&
          checkedBox.closest('.el-cascader-node')) ||
        menu.querySelector('.el-cascader-node.in-active-path') ||
        menu.querySelector('.el-cascader-node.is-active')
      if (node) scrollMenuToNode(menu, node)
    })
  }
  const run = () => {
    const panel = vm && vm.$refs && vm.$refs.panel
    if (panel && typeof panel.getCheckedNodes === 'function') {
      try {
        const checked = panel.getCheckedNodes(true) || []
        const first = checked[0]
        if (
          first &&
          first.pathNodes &&
          first.pathNodes.length &&
          typeof panel.expandNodes === 'function'
        ) {
          panel.activePath = []
          panel.expandNodes(first.pathNodes.slice(0, -1))
        }
      } catch (e) {
        /* ignore */
      }
    }
    if (panel && panel.$el) locateMenus(panel.$el)
    Array.prototype.forEach.call(
      document.querySelectorAll('.el-cascader__dropdown'),
      (el) => {
        if (!el || el.style.display === 'none' || !el.offsetHeight) return
        locateMenus(el)
      }
    )
  }
  setTimeout(run, 50)
  setTimeout(run, 180)
}

export function getLevelArray(data, obj) {
  const uid = obj && obj.uid ? obj.uid : 'uid'
  const label = obj && obj.label ? obj.label : 'label'
  const childUid = obj && obj.childUid ? obj.childUid : 'childUid'
  const childLabel = obj && obj.childLabel ? obj.childLabel : 'childLabel'
  const sumKeys = obj && obj.sumKeys ? obj.sumKeys : []
  const keepKeys = obj && obj.keepKeys ? obj.keepKeys : []
  const joinKeys = obj && obj.joinKeys ? obj.joinKeys : []
  const keys = getRemoveRepeat(data, [uid])
  var levelArray = []
  for (var i = 0; i < keys[uid].length; i++) {
    let newObj = {}
    newObj.children = data.filter((item) => {
      return keys[uid][i] === item[uid]
    })
    newObj.uid = newObj.children[0][uid]
    newObj.label = label ? newObj.children[0][label] : Date.now() + 'label'
    if (keepKeys) {
      for (var t = 0; t < keepKeys.length; t++) {
        newObj[keepKeys[t]] = newObj.children[0][keepKeys[t]]
      }
    }
    if (sumKeys) {
      for (var k = 0; k < sumKeys.length; k++) {
        newObj[sumKeys[k]] = getSameAttribute(
          newObj.children,
          sumKeys[k]
        ).addValue
      }
    }
    if (joinKeys) {
      for (var l = 0; l < joinKeys.length; l++) {
        newObj[joinKeys[l]] = getSameAttribute(
          newObj.children,
          joinKeys[l],
          obj.joinType
        ).joinString
      }
    }
    newObj.children.forEach((item) => {
      item.uid = item[childUid]
      item.label = item[childLabel]
    })
    levelArray.push(newObj)
  }
  return levelArray
}

// 将对象数组按照对象中某个属性值归类，返回归类后的类别对象
export function classifyArray(data, prop) {
  var result = data.reduce((acc, cur) => {
    if (cur[prop] && acc[cur[prop]]) {
      acc[cur[prop]].push(cur)
    } else if (cur[prop] && !acc[cur[prop]]) {
      acc[cur[prop]] = [cur]
    }
    return acc
  }, {})
  return result
}

// 根据单层级对象数组各对象元素中层级关系字段值重组数组为树形结构
/* {
  uidKey,
  parentKey,
  sumKeys,
  joinKeys
} */
export function getTreeArray(data, params) {
  if (!data || data.length <= 0) return data
  const topUid = params && params.topUid ? params.topUid : '1'
  const uidKey = params && params.uidKey ? params.uidKey : 'uid'
  const parentKey = params && params.parentKey ? params.parentKey : 'parentUid'
  const childrenKey =
    params && params.childrenKey ? params.childrenKey : 'children'
  const keepKeys = params ? params.keepKeys : null
  const sumKeys = params ? params.sumKeys : null
  const joinKeys = params ? params.joinKeys : null
  var dataMap = {}
  var treeArray = []
  for (let i = 0; i < data.length; i++) {
    // 数组按照uidkey值为新key全映射为对象，并初始化树形结构的根目录
    var a = data[i]
    dataMap[a[uidKey]] = a
    if (topUid && a[parentKey] === topUid) {
      treeArray.push(a)
    }
  }
  for (let j = 0; j < data.length; j++) {
    // 将对象按照其parentKey在映射对象中其父级对象并push仅其children属性数组
    var b = data[j]
    if (dataMap[b[parentKey]]) {
      dataMap[b[parentKey]][childrenKey] = dataMap[b[parentKey]][childrenKey]
        ? dataMap[b[parentKey]][childrenKey]
        : []
      dataMap[b[parentKey]][childrenKey].push(b)
      if (keepKeys) {
        for (let index = 0; index < keepKeys.length; index++) {
          const keepKey = keepKeys[index]
          dataMap[b[parentKey]][keepKey] =
            dataMap[b[parentKey]][childrenKey][0][keepKey]
        }
      }
      if (sumKeys) {
        for (let num = 0; num < sumKeys.length; num++) {
          const sumKey = sumKeys[num]
          dataMap[b[parentKey]][sumKey] = getSameAttribute(
            dataMap[b[parentKey]][childrenKey],
            sumKey
          ).addValue
        }
      }
      if (joinKeys) {
        for (let code = 0; code < joinKeys.length; code++) {
          const joinKey = joinKeys[code]
          dataMap[b[parentKey]][joinKey] = getSameAttribute(
            dataMap[b[parentKey]][childrenKey],
            joinKey
          ).addValue
        }
      }
    }
  }
  return treeArray
}

// 对象数组按照对象属性排序的方法
export function sortBy(props, orders) {
  return function (a, b) {
    if (!props && !orders) {
      return a - b
    } else if (!props && orders === 'reverse') {
      return b - a
    } else if (!props && orders === 'number') {
      return parseFloat(a) - parseFloat(b)
    } else if (!props && orders === 'reverseNum') {
      return parseFloat(b) - parseFloat(a)
    }

    for (let i = 0; i < props.length; i++) {
      const prop = props[i]
      const order = orders ? orders[i] : ''

      let indexA, indexB

      indexA = Array.isArray(order)
        ? order.indexOf(a[prop])
        : order === 'number' || order === 'reverseNum'
        ? parseFloat(a[prop])
        : a[prop]
      indexB = Array.isArray(order)
        ? order.indexOf(b[prop])
        : order === 'number' || order === 'reverseNum'
        ? parseFloat(b[prop])
        : b[prop]
      if (indexA < indexB) {
        return order === 'reverse' || order === 'reverseNum' ? 1 : -1
      } else if (indexA > indexB) {
        return order === 'reverse' || order === 'reverseNum' ? -1 : 1
      }
    }

    return 0
  }
}

// 多层级对象数组按某相同属性多层级排序
export function sortArray(arr, props, orders) {
  var newArr = arr && arr.length ? [...arr].sort(sortBy(props, orders)) : []
  newArr.forEach((item) => {
    if (item.children && item.children.length) {
      item.children = sortArray(item.children, props, orders)
    }
  })

  return newArr
}

// 返回树形对象数组的key数组，不含半选,key为空时返回选择的节点数据；
export function getDefaultKeys(data, key, arr) {
  if (!data.children || !data.children.length) {
    if (key === '') {
      return arr.push(data)
    } else {
      return arr.push(data[key])
    }
  }
  data.children.forEach((item) => {
    getDefaultKeys(item, key, arr)
  })
}

// 返回树形对象数组的key数组或节点数据，包含半选元素, key为空时返回选择的节点数据；
export function getDefaultHalfKeys(data, key, arr) {
  if (key === '') {
    arr.push(data)
    if (data.children && data.children.length) {
      data.children.forEach((item) => {
        getDefaultHalfKeys(item, key, arr)
      })
    }
  } else {
    if (data[key]) {
      arr.push(data[key])
      if (data.children && data.children.length) {
        data.children.forEach((item) => {
          getDefaultHalfKeys(item, key, arr)
        })
      }
    }
  }
  return arr
}

// 根据树形对象数组某节点key属性返回其node节点数据
export function getNode(data, key, value) {
  var node
  for (var i = 0; i < data.length; i++) {
    if (data[i][key] === value) {
      node = data[i]
      break
    }
    if (data[i].children && data[i].children.length) {
      node = getNode(data[i].children, key, value)
      if (node) {
        break
      }
    }
  }
  return node
}

// 根据树形对象数组某key属性返回预期值的所有node节点数组
export function getNodes(data, key, value) {
  var nodes = []
  if (data.length) {
    data.forEach((item) => {
      if (item.children && item.children.length) {
        nodes = nodes.concat(getNodes(item.children, key, value))
      }
      if (item[key] === value) {
        nodes.push(item)
      }
    })
  }
  return nodes
}

// 根据树形对象数组某key属性返回预期值的所有最底层node节点数组
export function getBottomNodes(data, key, value) {
  var nodes = []
  if (data.length) {
    data.forEach((item) => {
      if (item.children && item.children.length) {
        nodes = nodes.concat(getBottomNodes(item.children, key, value))
      } else {
        if (item[key] === value) {
          nodes.push(item)
        }
      }
    })
  }
  return nodes
}

// 根据树形对象数组某节点key属性返回其路径上所有上级及其自身对应属性的keys数组
export function getRouteKeys(data, key, value) {
  var routeKeys = []
  var hasKeyValue = false
  for (var i = 0; i < data.length; i++) {
    hasKeyValue = getNodeKey(data[i], key, value)
    if (!hasKeyValue) {
      routeKeys.pop()
    } else {
      break
    }
  }
  function getNodeKey(node, key, value) {
    routeKeys.push(node[key])
    if (node[key] === value) {
      hasKeyValue = true
    }
    if (node.children && node.children.length && !hasKeyValue) {
      for (var i = 0; i < node.children.length; i++) {
        hasKeyValue = getNodeKey(node.children[i], key, value)
        if (!hasKeyValue) {
          routeKeys.pop()
        } else {
          break
        }
      }
    }
    return hasKeyValue
  }
  return routeKeys
}

// 根据树形对象数组某节点key属性返回其路径上所有上级及其自身node数组
export function getRouteNodes(data, key, value) {
  var routeNodes = []
  var hasKeyValue = false
  for (var i = 0; i < data.length; i++) {
    hasKeyValue = getNodeKey(data[i], key, value)
    if (!hasKeyValue) {
      routeNodes.pop()
    } else {
      break
    }
  }
  function getNodeKey(node, key, value) {
    routeNodes.push(node)
    if (node[key] === value) {
      hasKeyValue = true
    }
    if (node.children && node.children.length && !hasKeyValue) {
      for (var i = 0; i < node.children.length; i++) {
        hasKeyValue = getNodeKey(node.children[i], key, value)
        if (!hasKeyValue) {
          routeNodes.pop()
        } else {
          break
        }
      }
    }
    return hasKeyValue
  }
  return routeNodes
}

// 比对arr2较arr1缺少的元素
export function getSurplusKeys(arr1, arr2, key) {
  const arr = []
  for (var i = 0; i < arr1.length; i++) {
    if (
      (!key && arr2.indexOf(arr1[i]) === -1) ||
      (key &&
        !arr2.some((item) => {
          return item[key] === arr1[i][key]
        }))
    ) {
      arr.push(arr1[i])
    }
  }
  return arr
}

export function testid(id) {
  // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
  var format =
    /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
  //号码规则校验
  if (!format.test(id)) {
    return { status: 0, msg: '身份证号码不合规' }
  }
  //区位码校验
  //出生年月日校验  前正则限制起始年份为1900;
  var year = id.substr(6, 4), //身份证年
    month = id.substr(10, 2), //身份证月
    date = id.substr(12, 2), //身份证日
    time = Date.parse(month + '-' + date + '-' + year), //身份证日期时间戳date
    now_time = Date.parse(new Date()), //当前时间戳
    dates = new Date(year, month, 0).getDate() //身份证当月天数
  if (time > now_time || date > dates) {
    return { status: 0, msg: '身份证号出生日期不合规' }
  }
  //校验码判断
  var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2) //系数
  var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2') //校验码对照表
  var id_array = id.split('')
  var sum = 0
  for (var k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k])
  }
  if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
    return { status: 0, msg: '身份证校验码不合规' }
  }
  return { status: 1, msg: '校验通过' }
}

// 给对象或数组中拼接其副本元素
export function addCopy(data) {
  var newData = JSON.parse(JSON.stringify(data))
  if (data instanceof Array) {
    for (var i = 0; i < data.length; i++) {
      newData.push(data[i])
    }
  } else {
    for (const key in data) {
      const newKey = key + 'copy'
      newData[newKey] = data[key]
    }
  }
  return newData
}

// 获取对象或数组中相同key的属性值数组及其拼接值和数值和；
// 或者将以相同字符joinType连接的字符串分隔为数组，并求数值和同时按照key值组装为对象数组;
// 或者将对象value统计数值和及其字符串拼接值，并按照key值更换对象对应键名，默认在原键名前拼接，join提供拼接的位置，L\F
export function getSameAttribute(data, key, join) {
  var sameAttribute = {}
  sameAttribute.values = []
  if (data instanceof Array && !key) {
    sameAttribute.values = data
  } else if (data instanceof Array && key) {
    data.forEach((item) => {
      if (item[key] !== null && item[key] !== undefined) {
        sameAttribute.values.push(item[key])
      }
    })
  } else if (typeof data === 'object') {
    sameAttribute.values = Object.values(data)
    sameAttribute.newObj = {}
    Object.keys(data).forEach((item) => {
      const newKey = join === 'R' ? item + key : key + item
      sameAttribute.newObj[newKey] = data[item]
    })
  } else if (typeof data === 'string' && !join) {
    sameAttribute.values = data.split()
  } else if (typeof data === 'string' && join) {
    sameAttribute.values = data.split(join)
  }
  sameAttribute.addValue = sameAttribute.values.reduce((pre, cur) => {
    return decimalAdd(pre, parseFloat(cur ? cur : 0))
  }, 0)
  if (typeof data === 'string' && key) {
    sameAttribute.objArray = sameAttribute.values.map((item) => {
      const obj = {}
      obj[key] = item
      return obj
    })
  }
  if (typeof data !== 'string') {
    sameAttribute.joinString = !join
      ? sameAttribute.values.join()
      : sameAttribute.values.join(join)
  }
  return sameAttribute
}

// 返回树形对象数组中相同key的属性值数组,不包含半选, key为空时返回选择的节点数据
export function getSameKeyValues(data, key) {
  var arr = []
  if (data.length) {
    data.forEach((item) => {
      if (!item.children || !item.children.length) {
        if (key === '') {
          arr.push(item)
        } else {
          arr.push(item[key])
        }
      } else {
        arr = arr.concat(getSameKeyValues(item.children, key))
      }
    })
  }
  return arr
}

// 返回树形对象数组的key数组或节点数据，包含半选元素, key为空时返回选择的节点数据；
export function getSameKeyHalfValues(data, key) {
  var arr = []
  if (data.length) {
    data.forEach((item) => {
      if (item.children && item.children.length) {
        arr = arr.concat(getSameKeyHalfValues(item.children, key))
      }
      if (key === '') {
        arr.push(item)
      } else {
        arr.push(item[key])
      }
    })
  }
  return arr
}

export function getCapitalLetters() {
  return Array(26)
    .fill('')
    .map((item, index) => {
      return String.fromCharCode(index + 65)
    })
}

export function getLowercaseLetters() {
  return Array(26)
    .fill('')
    .map((item, index) => {
      return String.fromCharCode(index + 97)
    })
}

export function missingPersonArchiveTip(names, archiveName) {
  if (!names) return ''
  return (
    names +
    '尚未添加' +
    archiveName +
    '，请先到人员档案或进场信息中补录后再操作'
  )
}

function pageTableExtraHeight(tableEl) {
  if (!tableEl || !tableEl.querySelector) {
    return 0
  }
  const radios = tableEl.querySelector('.el-radio-group')
  const tag = tableEl.querySelector('.tag')
  return (radios ? radios.offsetHeight + 8 : 0) + (tag ? tag.offsetHeight : 0)
}

function pageTablePaginationHeight(tableEl) {
  if (!tableEl || !tableEl.querySelector) {
    return 40
  }
  const pagination = tableEl.querySelector('.pagination')
  return pagination ? pagination.offsetHeight : 40
}

export function calcPageTableMaxHeight(checkEl, tableEl, extraShrink) {
  const extra = pageTableExtraHeight(tableEl)
  const paginationH = pageTablePaginationHeight(tableEl)
  const shrink = Number(extraShrink) || 0
  if (tableEl && tableEl.classList && tableEl.classList.contains('page-table')) {
    const main = tableEl.querySelector('.page-table-main')
    if (main && main.clientHeight > 80) {
      return Math.max(main.clientHeight - extra - 2 - shrink, 200)
    }
    if (tableEl.clientHeight > 80) {
      return Math.max(
        tableEl.clientHeight - paginationH - extra - 2 - shrink,
        200
      )
    }
  }
  const anchor = checkEl || tableEl
  if (!anchor || !anchor.closest) {
    return 0
  }
  const listBox = anchor.closest('.list_box')
  const checkHeight = checkEl ? checkEl.offsetHeight : 0
  if (listBox && listBox.clientHeight) {
    const body = listBox.querySelector('.el-card__body')
    let pad = 0
    if (body && window.getComputedStyle) {
      const style = window.getComputedStyle(body)
      pad =
        (parseFloat(style.paddingTop) || 0) +
        (parseFloat(style.paddingBottom) || 0)
    }
    const tabs = listBox.querySelector('.el-tabs')
    const tabsH = tabs ? tabs.offsetHeight : 0
    return Math.max(
      listBox.clientHeight -
        pad -
        checkHeight -
        paginationH -
        extra -
        tabsH -
        shrink,
      200
    )
  }
  return Math.max(
    document.documentElement.clientHeight - checkHeight - 140 - extra - shrink,
    200
  )
}

export function applyPageTableRowSize(tableRootEl, tableMaxHeight) {
  if (!tableRootEl || !tableRootEl.style || !tableMaxHeight) {
    return
  }
  const footer = tableRootEl.querySelector('.el-table__footer-wrapper')
  const units = 11 + (footer && footer.offsetHeight ? 1 : 0)
  const cellH = (tableMaxHeight - 4) / units
  let pad = Math.floor((cellH - 24) / 2)
  pad = Math.min(11, Math.max(0, pad))
  tableRootEl.style.setProperty('--page-table-cell-pad', pad + 'px')
}

export function isPhoneTableColumn(item) {
  if (!item) return false
  const prop = String(item.prop || '')
  const label = String(item.label || '')
  return /phone|telphone|telephone/i.test(prop) || label.includes('手机号')
}

export function isViewPageStatus(status) {
  return status === 'check' || status === 'outsideCheck'
}

export function fitViewTextareaAutosize(autosize, pageStatus) {
  let size = autosize
  if (typeof size === 'function') {
    try {
      size = size()
    } catch (e) {
      size = true
    }
  }
  if (!isViewPageStatus(pageStatus)) return size
  if (!size || size === true) {
    return { minRows: 2 }
  }
  const minRows = parseInt(size.minRows || size.min, 10) || 2
  return { minRows }
}

function opButtonName(btn) {
  if (btn == null) return ''
  if (typeof btn === 'string') return btn
  return btn.name || btn.buttonName || ''
}

function estimateButtonsWidth(buttons) {
  if (!Array.isArray(buttons) || !buttons.length) return 72
  const content = buttons.reduce((sum, btn) => {
    const name = opButtonName(btn)
    if (!name) return sum
    const hasIcon = typeof btn === 'object' && !!btn.icon
    const chars = Math.max(String(name).length, 2)
    return sum + 32 + (hasIcon ? 14 : 0) + chars * 12 + 8
  }, 20)
  return Math.max(content, 72)
}

function resolveOpButtons(item, row) {
  const buttons = item && item.buttons
  if (Array.isArray(buttons)) return buttons
  if (typeof buttons !== 'function') return []
  try {
    let sample = buttons(row || {})
    if (typeof sample === 'function') sample = sample(row || {})
    return Array.isArray(sample) ? sample : []
  } catch (e) {
    return []
  }
}

function estimateOpColumnWidth(item, rows) {
  let estimated = 0
  const seen = resolveOpButtons(item)
  if (seen.length) estimated = Math.max(estimated, estimateButtonsWidth(seen))
  if (Array.isArray(rows) && rows.length) {
    const limit = Math.min(rows.length, 30)
    for (let i = 0; i < limit; i++) {
      // 禁用按钮仍占位展示时，按全部按钮估算列宽
      const list = resolveOpButtons(item, rows[i])
      if (list.length) {
        estimated = Math.max(estimated, estimateButtonsWidth(list))
      }
    }
  }
  if (!estimated) estimated = 72
  const cap = parseInt(item && item.width, 10) || 0
  if (cap > 0) return Math.min(estimated, cap)
  return estimated
}

export function fitTableColumnSize(item, rows) {
  if (!item) {
    return { width: null, minWidth: null }
  }
  if (item.buttons) {
    const size = estimateOpColumnWidth(item, rows) + 'px'
    return {
      width: size,
      minWidth: size
    }
  }
  if (item.keepWidth) {
    const size = item.width || item.minWidth || null
    return {
      width: size,
      minWidth: item.minWidth || size
    }
  }
  if (item.overflowWidth === true) {
    return {
      width: null,
      minWidth: item.minWidth || item.width || null
    }
  }
  if (isPhoneTableColumn(item)) {
    const byLabel = String(item.label || '').length * 20
    const explicit = parseInt(item.width || item.minWidth, 10) || 0
    const size = Math.max(130, byLabel, explicit) + 'px'
    return {
      width: size,
      minWidth: size
    }
  }
  const source = item.minWidth || item.width
  const parsed = parseInt(source, 10)
  if (!parsed) {
    return {
      width: null,
      minWidth: null
    }
  }
  if (item.minWidth && !item.width) {
    return {
      width: null,
      minWidth: item.minWidth
    }
  }
  return {
    width: null,
    minWidth: Math.min(parsed, 150) + 'px'
  }
}

export function fillOrphanDetailSpans(details, getSpan) {
  if (!Array.isArray(details) || !details.length) return []
  const visible = []
  details.forEach((item, index) => {
    if (!item || item.isShow === false) return
    const span =
      typeof getSpan === 'function'
        ? Number(getSpan(item, index))
        : Number(item.span) || 12
    visible.push({ item, index, span: span > 0 ? span : 12 })
  })
  const spanMap = {}
  let used = 0
  visible.forEach((entry, i) => {
    let span = entry.span
    if (used + span > 24) used = 0
    const next = visible[i + 1]
    const nextSpan = next ? next.span : 24
    if (used + span < 24 && used + span + nextSpan > 24) {
      span = 24 - used
      used = 0
    } else {
      used += span
      if (used >= 24) used = 0
    }
    spanMap[entry.index] = span
  })
  return details.map((item, index) => {
    if (!item || item.isShow === false) return item
    const span = spanMap[index]
    if (span == null) return item
    return Object.assign({}, item, { span })
  })
}
